import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'components/Luxkit/Typography/Heading'
import React, { useMemo } from 'react'
import ExperienceSearchList from '../ExperienceLists/ExperienceSearchList'
import { ExperienceSortTypes } from 'actions/ExperienceActions'
import { pluralizeToString } from 'lib/string/pluralize'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import Group from 'components/utils/Group'
import useExperiencesSearchFilters from '../hooks/useExperiencesSearchFilters'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { getListName } from 'analytics/enhanced-ecommerce'

const Loader = styled(LoadingIndicator)`
  padding: 0;
`

interface Props {
  list: App.ApiCallState<{
    ids: Array<string>;
    placeId: string;
  }>
  destinationName: string;
  sortBy?: ExperienceSortTypes;
  excludeIds?: Array<string>;
}

function ExperienceSearchPageList(props: Props) {
  const { sortBy } = useExperiencesSortOptions()
  const { list, excludeIds } = props
  const fetching = !list || list.fetching

  const { searchFilters } = useExperiencesSearchFilters()
  const validItemsLength = useMemo(() => list.ids.filter(id => !excludeIds?.includes(id)).length, [list, excludeIds])
  const tracking = useOfferListTracking(
    getListName('OfferList', 'EXPERIENCES', 'Experiences Page Offer List'),
    { ias: { list: 'experiences' } },
  )

  return (
    <VerticalSpacer gap={16}>
      <Heading variant="heading3">
        Our handpicked experiences{!!props.destinationName && props.destinationName !== 'Anywhere' && ` in ${props.destinationName}`}
      </Heading>
      <Group direction="horizontal" verticalAlign="center">
        {!fetching && list && <BodyText variant="large">{pluralizeToString('experience', validItemsLength)}</BodyText>}
        {fetching && <Loader inline />}
      </Group>
      <OfferListEventsProvider tracking={tracking}>
        <ExperienceSearchList
          placeId={list.placeId}
          sortBy={sortBy}
          categoryCodes={searchFilters.categoryCodes}
          priceGte={searchFilters.priceGte}
          priceLte={searchFilters.priceLte}
          excludeIds={excludeIds}
        />
      </OfferListEventsProvider>
    </VerticalSpacer>
  )
}

ExperienceSearchPageList.defaultProps = {
  categories: [],
}

export default ExperienceSearchPageList
